export default function Gallery() {
  const galleryImages = [
    {
      url: 'https://public.readdy.ai/ai/img_res/53c9b67859acbbaf41f74a126c26ebb4.jpg',
      alt: 'Detailed Sports Car',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Clean%20luxury%20car%20interior%20with%20pristine%20leather%20seats%20perfect%20dashboard%20and%20immaculate%20detail%20work%20in%20natural%20lighting%20simple%20background%20automotive%20interior%20perfection&width=800&height=600&seq=gallery-002&orientation=landscape',
      alt: 'Interior Detailing',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Car%20paint%20surface%20showing%20water%20beading%20effect%20from%20ceramic%20coating%20protection%20with%20brilliant%20shine%20and%20hydrophobic%20properties%20simple%20background%20automotive%20protection%20technology&width=800&height=600&seq=gallery-003&orientation=landscape',
      alt: 'Ceramic Coating',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Professional%20car%20detailing%20process%20showing%20careful%20paint%20correction%20and%20polishing%20work%20with%20precision%20tools%20and%20expert%20technique%20simple%20background%20automotive%20craftsmanship&width=800&height=600&seq=gallery-004&orientation=landscape',
      alt: 'Paint Correction',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Luxury%20vehicle%20exterior%20after%20complete%20detailing%20showing%20flawless%20glossy%20paint%20perfect%20trim%20and%20pristine%20wheels%20in%20studio%20setting%20simple%20background%20automotive%20detailing%20excellence&width=800&height=600&seq=gallery-005&orientation=landscape',
      alt: 'Exterior Detail',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Crystal%20clear%20restored%20car%20headlights%20showing%20perfect%20transparency%20and%20brightness%20after%20professional%20restoration%20work%20simple%20background%20automotive%20restoration%20quality&width=800&height=600&seq=gallery-006&orientation=landscape',
      alt: 'Headlight Restoration',
    },
  ];

  return (
    <section id="gallery" className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            Our Work Speaks for Itself
          </h2>
          <p className="text-base sm:text-lg text-gray-700 max-w-3xl mx-auto px-4">
            See the difference professional detailing makes. Every vehicle tells a story of precision and care.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="w-full h-64 sm:h-72 lg:h-80 rounded-2xl overflow-hidden hover:scale-105 transition-transform duration-300 cursor-pointer"
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover object-top"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
